import { ActiveCallsBlockStyle } from './ActiveCallBlock.style'
import { AudioSettingsStyle } from './AudioSettings.style'
import { CallBlockStyle } from './CallBlock.style'
import { CallButtonStyle } from './CallButton.style'
import { CallContactButtonMenu } from './CallContactButton.style'
import { CallContactButton } from './CallContactButton.style'
import { CallControlStyle } from './CallControl.style'
import { CallErrorStyle } from './CallError.style'
import { CallHeaderStyle } from './CallHeader.style'
import { CallIconStyle } from './CallIcon.style'
import { CallSoundIndicatorStyle } from './CallSoundIndicator.style'
import { ContactCard } from './ContactCard.style'
import { ContactCardsList } from './ContactCardsList.style'
import { DeleteButtonStyle } from './DeleteButton.style'
import { DialpadShowButton } from './DialpadShowButton.style'
import { EmptyListItemStyle } from './EmptyListItem.style'
import { ExtensionSelector } from './ExtensionSelector.style'
import { FeedbackToastStyle } from './FeedbackToast.style'
import { IncomingCallButtonStyle } from './IncomingCallButton.style'
import { IncomingCallModalStyle } from './IncomingCallModal.style'
import { KeypadStyle } from './Keypad.style'
import { NumberInputStyle } from './NumberInput.style'
import { OnboardingStyle } from './Onboarding.style'
import { ParkCallMenuStyle } from './ParkCallMenu.style'
import { ParkCallMenuItemStyle } from './ParkCallMenuItem.style'
import { ParkTargetStyle } from './ParkTarget.style'
import { PhoneSearchInput } from './PhoneSearchInput.style'
import { QuickDialListItemStyle } from './QuickDialListItem.style'
import { QuickDialViewStyle } from './QuickDialView.style'
import { TransferHeaderStyle } from './TransferHeader.style'
import { TransferTargetStyle } from './TransferTarget.style'

export const phoneComponentStyles = {
  components: {
    ActiveCallsBlockStyle,
    AudioSettingsStyle,
    CallBlockStyle,
    CallButtonStyle,
    CallContactButtonMenu,
    CallContactButton,
    CallControlStyle,
    CallErrorStyle,
    CallHeaderStyle,
    CallIconStyle,
    CallSoundIndicatorStyle,
    ContactCard,
    ContactCardsList,
    DeleteButtonStyle,
    DialpadShowButton,
    EmptyListItemStyle,
    ExtensionSelector,
    FeedbackToastStyle,
    IncomingCallButtonStyle,
    IncomingCallModalStyle,
    KeypadStyle,
    NumberInputStyle,
    OnboardingStyle,
    ParkCallMenuItemStyle,
    ParkCallMenuStyle,
    ParkTargetStyle,
    PhoneSearchInput,
    QuickDialListItemStyle,
    QuickDialViewStyle,
    TransferHeaderStyle,
    TransferTargetStyle,
  },
}
